import { useMemo } from 'react'

export default function useDataTransform(props, data) {
  return useMemo(() => {
    return data?.[0] || null
  }, [data])
}
